var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1422_54201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.123 3.00244H7.62305C5.00342 3.00244 2.87305 5.13282 2.87305 7.75244V36.2524C2.87305 38.8721 5.00342 41.0024 7.62305 41.0024H36.123C38.7427 41.0024 40.873 38.8721 40.873 36.2524V7.75244C40.873 5.13282 38.7427 3.00244 36.123 3.00244Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9375 22.0005H29V17.2505C29 15.9395 30.064 16.063 31.375 16.063H33.75V10.1255H29C25.0646 10.1255 21.875 13.3151 21.875 17.2505V22.0005H17.125V27.938H21.875V41.0005H29V27.938H32.5625L34.9375 22.0005Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1422_54201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(2.87305 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.6b07b64591ea7ff56d0881fecf5dd503.svg";
export { ForwardRef as ReactComponent };